import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { COMMERCIAL_FILTER_QUERY } from "graphql/commercialFilter";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let commercialFilterClient = null;

const getCommercialFilterClient = () => {
  if (commercialFilterClient) {
    return commercialFilterClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  commercialFilterClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return commercialFilterClient;
};

export async function fetchCommercialFilter() {
  try {
    const client = getCommercialFilterClient();

    const { data } = await client.query({
      query: COMMERCIAL_FILTER_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Commercial Filter GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Commercial Filter GraphQL error:", error);
    throw error;
  }
}


